import {
  CreateBackupVaultApi,
  ListVaultAccountsApi,
  UpdateBackupVaultNameApi,
  type Configuration,
  VaultsApi,
  type CreateBackupVaultInput,
} from '@repo/api-gw-sdk';

import type { BackupVault } from '@/data/vaults/backupVault';

import type { HttpClient } from './httpClient';

const baseUrl = '/vaults';

export const vaults = (
  httpClient: HttpClient,
  config: Configuration,
  currentProjectId: string
) => {
  const vaultsApi = new VaultsApi(config);
  const createBackupVaultApi = new CreateBackupVaultApi(config);
  const updateBackupVaultNameApi = new UpdateBackupVaultNameApi(config);
  const listVaultAccountsApi = new ListVaultAccountsApi(config);
  return {
    list: () =>
      httpClient.execute(
        vaultsApi.listVaults.bind(vaultsApi),
        baseUrl,
        '/vaults',
        currentProjectId
      ),
    create: (vault: BackupVault) => {
      // Convert BackupVault to CreateBackupVaultInput
      const createInput: CreateBackupVaultInput = {
        name: vault.name,
        cloudProvider: vault.vaultAttributes.cloudProvider,
        cloudAccountId: vault.vaultAccountId,
        region: vault.region,
        cloudTenantId: vault.vaultAttributes.azure?.tenantId,
        encryptionKey: vault.vaultAttributes.aws?.encryptionKey,
      };

      return createBackupVaultApi.createVault(currentProjectId, createInput);
    },
    update: (vault: BackupVault) =>
      updateBackupVaultNameApi.updateVaultName(vault.id, currentProjectId, {
        name: vault.name,
      }),
    getAccounts: () =>
      httpClient.execute(
        listVaultAccountsApi.listVaultAccounts.bind(listVaultAccountsApi),
        baseUrl,
        'vault-accounts'
      ),
  };
};
